"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _reportUtil = require("../../utils/reportUtil");
var _componentUtils = require("../../common/componentUtils");
var _HTMLRenderer = _interopRequireDefault(require("../../common/components/HTMLRenderer"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */

const formatAdvantageCommon = (properties, options = {}) => {
  const _ref = properties || {},
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? '' : _ref$tag,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$desc = _ref.desc,
    desc = _ref$desc === void 0 ? '' : _ref$desc,
    _ref$porintId = _ref.porintId,
    porintId = _ref$porintId === void 0 ? '' : _ref$porintId,
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? 'default' : _ref$bg,
    _ref$bgColor = _ref.bgColor,
    bgColor = _ref$bgColor === void 0 ? '' : _ref$bgColor,
    _ref$bgImg = _ref.bgImg,
    bgImg = _ref$bgImg === void 0 ? '' : _ref$bgImg,
    _ref$footerTitle = _ref.footerTitle,
    footerTitle = _ref$footerTitle === void 0 ? '' : _ref$footerTitle,
    _ref$footerTitleHref = _ref.footerTitleHref,
    footerTitleHref = _ref$footerTitleHref === void 0 ? '' : _ref$footerTitleHref,
    _ref$advantageList = _ref.advantageList,
    advantageList = _ref$advantageList === void 0 ? [] : _ref$advantageList,
    _ref$caseList = _ref.caseList,
    caseList = _ref$caseList === void 0 ? [] : _ref$caseList,
    _ref$logoList = _ref.logoList,
    logoList = _ref$logoList === void 0 ? [] : _ref$logoList,
    _ref$logoLine = _ref.logoLine,
    logoLine = _ref$logoLine === void 0 ? '1' : _ref$logoLine,
    _ref$logoTitle = _ref.logoTitle,
    logoTitle = _ref$logoTitle === void 0 ? '' : _ref$logoTitle;
  const handledList = caseList === null || caseList === void 0 ? void 0 : caseList.map((activityItem, index) => {
    const _ref2 = activityItem || {},
      _ref2$text = _ref2.text,
      text = _ref2$text === void 0 ? '' : _ref2$text,
      _ref2$icon = _ref2.icon,
      icon = _ref2$icon === void 0 ? '' : _ref2$icon,
      _ref2$img = _ref2.img,
      img = _ref2$img === void 0 ? '' : _ref2$img,
      _ref2$btnText = _ref2.btnText,
      btnText = _ref2$btnText === void 0 ? '' : _ref2$btnText,
      _ref2$btnHref = _ref2.btnHref,
      btnHref = _ref2$btnHref === void 0 ? '' : _ref2$btnHref,
      _ref2$list = _ref2.list,
      list = _ref2$list === void 0 ? [] : _ref2$list,
      _ref2$recommends = _ref2.recommends,
      recommends = _ref2$recommends === void 0 ? [] : _ref2$recommends;
    const btnExtendProps = {
      'report-event': 'click_CaseLayout_tab_btn',
      'report-ext1': index,
      'report-ext2': btnText,
      'report-ext3': btnHref || '',
      target: '_blank'
    };
    return {
      text,
      list,
      recommends,
      btns: btnText ? /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
        type: 'solid-white',
        align: "center",
        icon: true,
        href: btnHref
      }, btnExtendProps), btnText) : null,
      img: (0, _componentUtils.doComponentsUploadEvent)(img).url,
      icon: (0, _componentUtils.doComponentsUploadEvent)(icon).url
    };
  });
  const handledLogoList = logoList === null || logoList === void 0 ? void 0 : logoList.map((activityItem, index) => {
    const _ref3 = activityItem || {},
      img = _ref3.img,
      _ref3$href = _ref3.href,
      href = _ref3$href === void 0 ? '' : _ref3$href,
      _ref3$tooltip = _ref3.tooltip,
      tooltip = _ref3$tooltip === void 0 ? '' : _ref3$tooltip;
    const btnExtendProps = {
      'report-event': 'click_CaseLayout_logo_item',
      'report-ext1': index,
      'report-ext2': href || '',
      target: '_blank'
    };
    return {
      tooltip,
      btnExtendProps,
      href,
      img: (0, _componentUtils.doComponentsUploadEvent)(img || '').url
    };
  });
  return {
    tag,
    title: title ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: title
    }) : '',
    desc: desc ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: desc
    }) : '',
    footerTitle,
    footerTitleHref,
    bg,
    bgColor,
    bgImg: (0, _componentUtils.doComponentsUploadEvent)(bgImg || '').url,
    porintId,
    logoLine,
    advantageList,
    caseList: handledList,
    logoList: handledLogoList,
    logoTitle
  };
};
function splitIntoGroups(arr, groups) {
  if (groups <= 0) return [];
  const len = arr.length;
  if (groups > len) {
    // 处理类型安全的分组
    const filled = arr.map(item => [item]);
    const empty = Array(groups - len).fill([]);
    return [...filled, ...empty];
  }
  const baseSize = Math.floor(len / groups);
  const remainder = len % groups;
  const result = [];
  let start = 0;
  for (let i = 0; i < groups; i++) {
    const chunkSize = baseSize + (i < remainder ? 1 : 0);
    result.push(arr.slice(start, start + chunkSize));
    start += chunkSize;
  }
  return result;
}
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatAdvantageCommo = formatAdvantageCommon(data, {
        domains
      }),
      tag = _formatAdvantageCommo.tag,
      title = _formatAdvantageCommo.title,
      desc = _formatAdvantageCommo.desc,
      footerTitle = _formatAdvantageCommo.footerTitle,
      footerTitleHref = _formatAdvantageCommo.footerTitleHref,
      bg = _formatAdvantageCommo.bg,
      bgColor = _formatAdvantageCommo.bgColor,
      bgImg = _formatAdvantageCommo.bgImg,
      porintId = _formatAdvantageCommo.porintId,
      _formatAdvantageCommo2 = _formatAdvantageCommo.logoLine,
      logoLine = _formatAdvantageCommo2 === void 0 ? '1' : _formatAdvantageCommo2,
      advantageList = _formatAdvantageCommo.advantageList,
      caseList = _formatAdvantageCommo.caseList,
      logoList = _formatAdvantageCommo.logoList,
      logoTitle = _formatAdvantageCommo.logoTitle;
    const mun = Number(logoLine);
    const logoListResult = splitIntoGroups(logoList, mun);
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId,
      className: "gems-materials-qci__newUI-caseLayout"
    }, (0, _reportUtil.reportShow)(['show_newUI_CaseLayout', componentKey, title || ''])), /*#__PURE__*/React.createElement(_tpmProductIntl.Section, {
      tag: tag,
      title: title,
      desc: desc,
      bg: bg,
      bgColor: bgColor,
      bgImg: bgImg,
      type: 'full',
      footLinks: footerTitle && footerTitleHref ? [{
        children: footerTitle,
        icon: true,
        href: footerTitleHref
      }] : [],
      className: `tpm-product-intl-case-layout__section ${!!logoListResult.length ? 'has-logo' : ''}`
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.CaseLayout, {
      advantageList: advantageList,
      caseList: caseList
    }), !!logoListResult.length && /*#__PURE__*/React.createElement(React.Fragment, null, logoTitle ? /*#__PURE__*/React.createElement(_tpmProductIntl.Panel, {
      title: logoTitle
    }, logoListResult.map((item, index) => /*#__PURE__*/React.createElement(_tpmProductIntl.CaseLogo, {
      logos: item || []
    }))) : logoListResult.map((item, index) => /*#__PURE__*/React.createElement(_tpmProductIntl.CaseLogo, {
      logos: item || []
    })))));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}